module.exports = __webpack_public_path__ + "static/media/2021-isuzu-dmax.ba3d8632.jpg";